export type ID = string;

export interface Role {
  id: ID;
  name: string;
  color: string;
}

export interface Project {
  id: ID;
  name: string;
  roleId: ID | null;
  createdAt: string;
}

export interface Task {
  id: ID;
  text: string;
  projectId: ID | null;
  done: boolean;
  createdAt: string;
  completedAt: string | null;
}

export interface WorkBlock {
  id: ID;
  title: string;
  projectId: ID | null;
  duration: number;
  date: string;
  done: boolean;
  createdAt: string;
}

export interface Capture {
  id: ID;
  text: string;
  createdAt: string;
}

export interface Intention {
  date: string;
  text: string;
}

export interface WeeklyItem {
  id: ID;
  text: string;
}

export interface DailyItem {
  id: ID;
  text: string;
  done: boolean;
}

export interface DayBlock {
  id: ID;
  time: string;
  label: string;
  title: string;
  done: boolean;
}

export interface WeeklyPlan {
  week: string; // week key, e.g. Monday date
  items: WeeklyItem[]; // fixed length 3
}

export interface DailyPlan {
  date: string; // YYYY-MM-DD
  items: DailyItem[]; // fixed length 3
}

export interface DayFlow {
  date: string; // YYYY-MM-DD
  blocks: DayBlock[]; // fixed length 7
}

export interface AppData {
  onboarded: boolean;
  userName: string;
  intention: Intention | null;
  roles: Role[];
  projects: Project[];
  tasks: Task[];
  workBlocks: WorkBlock[];
  captures: Capture[];
  focusBlockId: ID | null;
  focusMinutes: number;
  focusLabel: string | null;
  weekly: WeeklyPlan;
  daily: DailyPlan;
  flow: DayFlow;
  lastReset: string | null;
}

export const SAGE_PALETTE = [
  "#8A9A86", // sauge
  "#B5C1B4", // sauge clair
  "#6D7C6A", // sauge profond
  "#9FC1BB", // vert d'eau
  "#9DB4C0", // bleu poussière
  "#C3B7D6", // lavande douce
  "#E5989B", // blush
  "#E0B0A0", // rose terreux
  "#D4A373", // argile
  "#DCC7A0", // sable
  "#A8C3A0", // menthe sauge
  "#CBB7A0", // taupe
];

// The 7 calm time blocks that give the day its rhythm.
export const DAY_RHYTHM: { time: string; label: string }[] = [
  { time: "07:00", label: "Réveil en douceur" },
  { time: "09:00", label: "Focus du matin" },
  { time: "11:00", label: "Élan de matinée" },
  { time: "13:00", label: "Pause & déjeuner" },
  { time: "15:00", label: "Focus de l'après-midi" },
  { time: "17:00", label: "Clôture du travail" },
  { time: "19:00", label: "Soirée calme" },
];

export const emptyData: AppData = {
  onboarded: false,
  userName: "",
  intention: null,
  roles: [],
  projects: [],
  tasks: [],
  workBlocks: [],
  captures: [],
  focusBlockId: null,
  focusMinutes: 25,
  focusLabel: null,
  weekly: { week: "", items: [] },
  daily: { date: "", items: [] },
  flow: { date: "", blocks: [] },
  lastReset: null,
};
